import {ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, ViewRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormBuilder, FormsModule} from "@angular/forms";
import {Session} from "../../../services/Session";
import {FormulaTestCaseService} from "../../../tpiq-services/formula-test-case.service";
import {takeUntil} from "rxjs/operators";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {State} from "../../../models/State";
import {NgxScrollEvent} from 'ngx-scroll-event/dist/ngx-scroll-event';
import {ToastService} from "../../../services/Toast.service";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {LoadingService} from "../../../services/LoadingService";
import {ActivatedRoute, Router} from "@angular/router";
import {PageTitleService} from "../../../services/PageTitle";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {StateService} from "../../../services/StateService";
import {TrackerPaginatedTableComponent} from "../../../tables/tracker-paginated-table/tracker-paginated-table.component";
import {CreateOrUpdateStrategyComponent} from "../create-or-update-strategy/create-or-update-strategy.component";
import {StrategyTagsSearchComponent} from "../../../search/strategy-tags-search/strategy-tags-search.component";

declare const _: any;

@Component({
  selector: 'app-tax-strategies-list',
  standalone: true,
  imports: [CommonModule, FormsModule, TrackerPaginatedTableComponent, CreateOrUpdateStrategyComponent, StrategyTagsSearchComponent],
  templateUrl: './tax-strategies-list.component.html',
  styleUrl: './tax-strategies-list.component.scss'
})
export class TaxStrategiesListComponent implements OnInit, OnDestroy {
  org: string;
  user: string;
  isAddTaxStrategy: boolean;
  editMode = false;
  taxStrategyTableData: any = {};
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  taxStrategiesSort: any = {};
  isLoading = true;
  nextIndex = 0;
  hasNextSet = false;
  hasTaxStrategyList = false;
  taxStrategiesList: any;
  searchKey: string;
  reveal: any = {
    addNewStrategy: false,
    hasUpdates: false,
    deletedByParent: false,
    deleteChildren: false,
    acceptAll: false,
    rules: false
  };
  parentStrategyId: any;
  currentStrategyId: any;
  showAllAccept = false;
  searchObj: any = {};
  selectedSearchValues: any;
  taxStrategy: any = {
    resources: {
      files: [],
      links: '',
      videos: [{
        id: '',
        name: ''
      }]
    },
    firmCustomizations: {
      files: [],
      content: ''
    },
    clientResourceFiles: []
  };
  stratagiesTypes: Array<any> = [];
  associatedWith: Array<any> = [
    {id: 'a627ccde-dd57-1090-cefa-fc965526a557', name: 'Effective Rate'},
    {id: '82c36191-8d6f-39e7-f711-947591551608', name: 'Marginal Rate'},
    {id: '5a314bc1-4534-0426-1db4-d18403485072', name: 'Cap Gain Rate'},
    {id: '23a5e1b2-03cf-6675-2596-0952387d4b46', name: 'C Corp Flat Rate'},
    {id: '393a6f91-8222-11ef-bd9d-12ff30f54e53', name: 'Full Credit'},
    {id: '454ba189-8222-11ef-bd9d-12ff30f54e53', name: 'N/A'},
    {id: 'f637945b-e78e-11ef-a4a7-0e0adc17208f', name: 'Market Growth Rate'},
    {id: 'ce08f4de-b7f2-449c-9bf8-9674fbf6d0d5', name: 'Qualified Dividends'}];
  tempCustomRates: Array<any> = [];
  isCustomRateEdit = false;
  indexOfTempCustomRateObject: any;
  isMinimized = false;
  searchFilters: any;
  ruleStrategy: any = {rules: {}};
  isRulesLoading = false;
  isRulesSaving = false;
  isRulesEditable = false;
  ruleEditBackup: any;
  aiQRiskLevels: Array<any> = [
    { key: '1 - Minimal', value: 'Sustained' },
    { key: '2 - Low', value: 'More Likely Than Not' },
    { key: '3 - Moderate', value: 'Substantial Authority' },
    { key: '4 - Heightened', value: 'Reasonable Basis' },
    { key: '5 - Significant', value: 'Listed/Reportable' }
  ];
  allowedRuleOrgs: string[] = ['stag-taxplaniq', 'trialtaxplaniq'];
  isInternalUser = false;

  constructor(
    private toastService: ToastService,
    private switchBoard: SwitchBoard,
    private loadingService: LoadingService,
    private stateService: StateService,
    private _router: Router,
    private _route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private titleService: PageTitleService,
    private taxStrategyServices: ManageTaxStrategiesServices,
    private formulaTestCaseService: FormulaTestCaseService) {}

  ngOnInit() {
    this._init();
  }

  removeSearchItem(item, index) {
    this.searchFilters.splice(index, 1);
    this.switchBoard.onSearchTagDelete.next({filters: this.searchFilters, searchItem: item});
  }

  _init() {
    const base = this;
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
    this.formulaTestCaseService.checkInternalAccess(this.org, this.user).subscribe((response) => {
      this.isInternalUser = !!(response && response.internal);
    }, () => {
      this.isInternalUser = false;
    });
    const prevState = this.stateService.getPrevState();
    if (prevState && prevState.selectedId){
      this.searchKey = prevState.selectedId;
    }
    this.getFirmTagsData();
    this.getTaxStrategiesTableData(true);
    this.stateService.clearAllStates();
    this.switchBoard.onPageChangeListener.next({
      url: this._route.url,
      name: 'Strategy Library',
      id: 'STRATEGIES_LIST'
    });
    this.switchBoard.onClickPrev.pipe(takeUntil(this.destroy$)).subscribe(title => {});

    this.switchBoard.onToggleFeedback.next({
      display: true,
      pageName: 'Strategy list page'
    });
    this.switchBoard.onToastConfirm
      .pipe(takeUntil(this.destroy$)).subscribe(toast => {
      if (toast.data && toast.data.isPublishStrategy) {
        this.publishStrategyToAllInstances(toast.data);
      } else if (toast.data) {
        this.deleteTaxStrategy();
      }
    });

    this.switchBoard.onStrategyTagsAdvSearch.pipe(takeUntil(this.destroy$)).subscribe(search => {
      if (search.selectedValues) {
        this.selectedSearchValues = search.selectedValues || [];
      }
      if (search.filters) {
        this.searchFilters = search.filters || [];
      }
      if (search.searchObj) {
        let obj = {
          searchFilters: this.getSelectedTagValues(search.selectedValues),
          status: search.searchObj.status,
          category: search.searchObj.category,
          complexity: search.searchObj.complexity,
          urgency: search.searchObj.urgency,
          riskLevel: search.searchObj.riskLevel,
          burden: search.searchObj.burden,
          amountType: search.searchObj.amountType,
          requiresInvestment: search.searchObj.requiresInvestment,
          applicableTo: search.searchObj.applicableTo,
        };
        obj['searchKey'] = (obj.searchFilters.length > 0) ? 'tags' : '';

        this.searchObj = obj;
        this.nextIndex = 0;
        this.fetchNextSet(true);
      }
    });
  }

  getSelectedTagValues(tagsData) {
    const tags = [];
    _.each(tagsData, (tag) => {
      tags.push(tag.id);
    });
    return tags;
  }

  getFirmTagsData() {
    this.taxStrategyServices.getTagsDataForFirm(this.org, this.user)
      .subscribe(response => {
      }, error => {
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.switchBoard.onToggleFeedback.next({
      display: false
    });
  }

  gotoDefaultPage() {
    const prevState = this.stateService.getPrevState();
    if (prevState) {
      this.stateService.pop();
      this._router.navigate([prevState.url]);
    }
  }

  getTaxStrategiesTableData(refresh?) {
    this.titleService.setPageTitle('');
    this.showAllAccept = false;
    this.nextIndex = 0;
    this.hasNextSet = false;
    this.taxStrategyTableData.rows = [];
    this.resetTabData();
    this.fetchNextSet(refresh);
  }

  resetTabData() {
    this.isLoading = true;
    this.taxStrategiesSort = {};
    this.hasTaxStrategyList = false;
  }

  fetchNextSet(refresh) {
    let strategyStatus: any;
    if (this.nextIndex === 0 || this.hasNextSet) {
      this.loadingService.triggerLoadingEvent(true);
      const sortObj = this.getTabSortObject();
      let sortingRequest: any = this.getSortingObject(sortObj);
      if (sortingRequest == null) {
        sortingRequest = {
          fromIndex: this.nextIndex
        };
      }
      if (this.searchKey) {
        sortingRequest['searchKey'] = this.searchKey;
      }
      if (!_.isEmpty(this.searchObj)) {
        sortingRequest = {...sortingRequest, ...this.searchObj};
        sortingRequest['status'] = this.searchObj.status || '';
        sortingRequest['category'] = this.searchObj.category || '';
        sortingRequest['applicableTo'] = this.searchObj.applicableTo || '';
        strategyStatus = this.searchObj.status || 'Active';
      }

      this.loadingService.triggerLoadingEvent(true);
      this.taxStrategyServices.getPaginatedTaxStrategies(this.org, this.user, sortingRequest, null, null, strategyStatus)

        .subscribe(response => {
          this.isLoading = false;
          this.taxStrategiesList = response;
          this.loadingService.triggerLoadingEvent(false);
          this.nextIndex += response.strategies.length;
          this.hasNextSet = response.hasNextPage;
          if (this.searchKey){
            this.filterData();
          } else {
            this.buildTaxStrategiesTableData(response.strategies, refresh);
          }
        }, error => {
          this.handleError(error);
        });
    }
  }

  getTabSortObject() {
    return this.taxStrategiesSort;
  }

  getSortingObject(sortObject) {
    const base = this;
    if (!sortObject || Object.keys(sortObject).length === 0) {
        return {
            sortKey: 'name',
            sortOrder: 'asc',
            fromIndex: this.nextIndex
        };
    }
    for (const key in sortObject) {
      if (sortObject.hasOwnProperty(key) && sortObject[key]) {
        return {
          sortKey: key,
          sortOrder: sortObject[key],
          fromIndex: this.nextIndex
        };
      }
    }
    return null;
  }

  buildTaxStrategiesTableData(data, refreshTable?) {
    const base = this;
    this.taxStrategyTableData.options = {
      height: '76vh',
      selectorString: 'id',
      showSearch: false,
    };
    this.taxStrategyTableData.columns = [];
    this.taxStrategyTableData.columns = this.formatColumnsForTable(this.taxStrategiesList.columns);
    this.taxStrategyTableData.columns.push({name: 'actions', classes: 'overflow-css float-right', title: '', type: 'html', sortable: false});
    if (refreshTable) {
      this.taxStrategyTableData.rows = [];
    } else {
      this.taxStrategyTableData.rows = this.taxStrategyTableData.rows || [];
    }
    const rows = base.taxStrategyTableData.rows || [];
    data.forEach(function(tax){
      const row = base.createTableRow(tax);
      rows.push(row);
    });
    this.taxStrategyTableData = {...this.taxStrategyTableData, rows};
    this.handleSortOrder(this.taxStrategiesSort, this.taxStrategyTableData.columns);
    if (refreshTable) {
      this.hasTaxStrategyList = false;
    }
    this.loadingService.triggerLoadingEvent(false);

    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
    if (base.taxStrategyTableData.rows.length > 0) {
      base.isLoading = false;
    } else {
      base.isLoading = false;
    }
    base.hasTaxStrategyList = true;
  }

  formatColumnsForTable(data) {
    const base = this;
    const colsArray = [];
    let orderArray;
    if (typeof data !== 'string') {
      orderArray = data;
    } else {
      orderArray = JSON.parse(data);
    }
    _.each(Object.keys(orderArray), function(key) {
      if (key === 'Name') {
        colsArray.push({name: orderArray[key], title: key, type: 'html', classes: 'pointer zero-overflow', sortable: true});
      } else if (key == 'Tags'){
        colsArray.push({name: orderArray[key], title: key, type: 'html', classes: 'pointer tag-tooltip', sortable: false});
      } else if (key === 'Status'){
        // colsArray.push({name: orderArray[key], title: key, type: 'html', classes: 'pointer zero-overflow tracker-desc', sortable: true});
      } else {
        colsArray.push({name: orderArray[key], title: key, type: 'normal', classes: 'pointer zero-overflow', sortable: true});
      }

      if (key === 'Complexity') {
        colsArray.push(
          {name: 'urgency', title: 'Urgency', type: 'normal', classes: 'pointer zero-overflow', sortable: true},
          {name: 'riskLevel', title: 'Risk', type: 'normal', classes: 'pointer zero-overflow', sortable: true},
          {name: 'burden', title: 'Burden', type: 'normal', classes: 'pointer zero-overflow', sortable: true}
        );
      }
    });
    return colsArray;
  }

  createTableRow(todo) {
    const base = this;
    const row: any = {};
    const titletipClass = base.getTitleTooltipHtmlClass();

    _.each(todo, function(value, key){
      if (key == 'name') {
        row[key] = `<a class='actionOnId' data-action='view'>${todo[key]}</a>`;
      }  else if (key == 'implementationStatus'){
        // row[key] = `<span class="badge-tooltip"><i class="icon ion-ios-star" style="color: #FFCC00;"></i><span class="bottomTooltiptext status-tooltip">This strategy has been fully developed by the Meyer tax team, with attorney collaboration as needed</span></span>`;
      }  else if (key == 'tags') {
        const str = base.getSelectedTagNamesString(todo[key], 'label');
        row[key] = `<span class='icon badge-tooltip pointer'>${base.setTableProjectString(str)}<span style="max-width: 330px !important;min-width: 300px !important;white-space: pre-wrap !important;font-size: 12px" class='${titletipClass} clientTooltip'>` + str + `</span></span>`;
      }else {
        row[key] = todo[key];
      }
    });

    // Ensure display-friendly formatting for newly exposed columns
    row.complexity = base.formatComplexity(todo.complexity);
    row.urgency = base.formatUrgency(todo.urgency);
    row.riskLevel = base.formatRiskLevel(todo.riskLevel);
    row.burden = base.formatBurden(todo.burden);

    // Apply CURB (Complexity, Urgency, Risk, Burden) cell styling classes
    row['complexity-class'] = base.getCurbClassForField('complexity', todo.complexity);
    row['urgency-class'] = base.getCurbClassForField('urgency', todo.urgency);
    row['riskLevel-class'] = base.getCurbClassForField('riskLevel', todo.riskLevel);
    row['burden-class'] = base.getCurbClassForField('burden', todo.burden);

    row.actions = ``;
    const notesIcon = `<i class="material-icons strategy-action-icon">short_text</i>`;
    if (row.hasDocuments) {
      row.actions = row.actions + `<a class='action' data-action='documentsExist'><i class="icon ion-android-document strategy-action-icon"></i></a>`;
    }
    if (row.hasVideos) {
      row.actions = row.actions + `<a class='action' data-action='videosExist'><i class="icon ion-ios-videocam strategy-action-icon"></i></a>`;
    }
    if (row.parentDeleted) {
      row.actions = row.actions + `<a class='action' data-action='hasDeletedByParent'><i class="icon ion-arrow-down-c power-symbol strategy-action-icon" style="color: #F06459;"></i></a>`;
    }
    if (this.org !== 'trialtaxplaniq' && row.hasUpdates) {
      base.showAllAccept = true;
      row.actions = row.actions + `<a class='action' data-action='has-updates'><i class="icon ion-arrow-down-c power-symbol strategy-action-icon"></i></a>`;
    }
    if (row.status === 'Archived') {
      row.actions = row.actions + `<a class='action' data-action='moveToActive'><span class='icon badge je-badge'>Move to Active</span></a>`;
      if (row.canPublish) {
      row.actions += `<a class='action' data-action='publish'><span class='icon badge je-badge'>Publish</span></a>`;
      }
    }
    if (row.canPublish && row.status !== 'Archived') {
      row.actions = row.actions + `<a class='action' data-action='publish'><span class='icon badge je-badge'>Publish</span></a>`;
    }
    if (todo.locked){
      row.actions = row.actions + `<a class='action'><i class="icon ion-ios-locked-outline" style="color: #F06459;"></i></a>`;
    } else {
      if (this.allowedRuleOrgs.includes(this.org)) {
        row.actions = row.actions + `<a class='action' data-action='rules'>${notesIcon}</a>`;
      }
      row.actions = row.actions + `<a class='action' data-action='edit'><i class="material-icons strategy-action-icon">mode_edit</i></a><a class='action' data-action='delete'><span class='todo-del'><i class="material-icons delete">delete</i></span></a>`;
    }
    return row;
  }

  getTitleTooltipHtmlClass() {
    return this.taxStrategyTableData.rows && this.taxStrategyTableData.rows.length == 0 ? 'bottomTooltiptext taskBottomTitleTooltip' : 'topTooltiptext taskTopTitleTooltip';
  }

  setTableProjectString(inputString) {
    if (inputString && inputString.length > 25) {
      return inputString.substring(0, 25) + '....';
    } else {
      return inputString;
    }
  }

  getSelectedTagNamesString(obj, type) {
    let labels = [];
    _.forEach(obj, function (value) {
      labels.push(value[type]);
    });
    return labels.join(', ');
  }

  formatEnumValue(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const normalized = value.toString().replace(/_/g, ' ').replace(/\s+/g, ' ').trim();

    if (!normalized) {
      return '';
    }

    return normalized.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
  }

  formatRiskLevel(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const normalized = value.toString().replace(/_/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
    const labels: Record<string, string> = {
      'sustained': '1 - Minimal',
      'more likely than not': '2 - Low',
      'substantial authority': '3 - Moderate',
      'reasonable basis': '4 - Heightened',
      'listed/reportable': '5 - Significant'
    };

    return labels[normalized] || this.formatEnumValue(value);
  }

  formatComplexity(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const labels: Record<string, string> = {
      '1': '1 - Single Input',
      '2': '2 - Multiple Inputs',
      '3': '3 - Conditional',
      '4': '4 - Complex',
      '5': '5 - Specialized'
    };

    return labels[value.toString().trim()] || this.formatEnumValue(value);
  }

  formatUrgency(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const normalized = value.toString().replace(/_/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
    const labels: Record<string, string> = {
      'no deadline': '1 - No deadline',
      'annual': '2 - Annual',
      'quarterly': '3 - Quarterly',
      'weeks': '4 - Weeks',
      'days': '5 - Days'
    };

    return labels[normalized] || this.formatEnumValue(value);
  }

  formatBurden(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const normalized = value.toString().replace(/_/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
    const labels: Record<string, string> = {
      'referral only': '1 - Mostly the client',
      'light coordination': '2 - Client with advisor help',
      'shared work': '3 - Half client/advisor',
      'mostly advisor': '4 - Mostly tax advisor',
      'all advisor': '5 - Concierge',
      'all advisor (no vendor)': '5 - Concierge'
    };

    return labels[normalized] || this.formatEnumValue(value);
  }

  getCurbClassForField(field: 'complexity' | 'urgency' | 'riskLevel' | 'burden', value: any): string {
    const level = this.normalizeCurbLevelForField(field, value);
    if (!level) {
      return '';
    }

    return `curb-level-${level}`;
  }

  normalizeCurbLevelForField(field: 'complexity' | 'urgency' | 'riskLevel' | 'burden', value: any): number | null {
    if (value === null || value === undefined) {
      return null;
    }

    // Normalize: lowercase and convert underscores to spaces to align API enums like "NO_DEADLINE"/"LIGHT_COORDINATION"
    const strVal = value.toString().trim().toLowerCase();
    const normalizedVal = strVal.replace(/_/g, ' ').trim();

    const mappings: Record<string, number> = (() => {
      switch (field) {
        case 'complexity':
          return {};
        case 'urgency':
          return {
            'no deadline': 1,
            'annual': 2,
            'quarterly': 3,
            'weeks': 4,
            'days': 5,
          };
        case 'riskLevel':
          return {
            'sustained': 1,
            'more likely than not': 2,
            'substantial authority': 3,
            'reasonable basis': 4,
            'listed/reportable': 5,
          };
        case 'burden':
          return {
            'referral only': 1,
            'light coordination': 2,
            'shared work': 3,
            'mostly advisor': 4,
            'all advisor': 5,
            'all advisor (no vendor)': 5,
          };
        default:
          return {};
      }
    })();

    if (normalizedVal in mappings) {
      return mappings[normalizedVal];
    }

    // Match patterns like "level 1", "1", "01", etc.
    const match = normalizedVal.match(/level\s*([1-5])|\b([1-5])\b/);
    if (match) {
      const captured = match[1] || match[2];
      const num = parseInt(captured, 10);
      return num >= 1 && num <= 5 ? num : null;
    }

    return null;
  }

  handleSortOrder(sortOrder, columns) {
    _.each(columns, function(column){
      column.sortType = sortOrder[column.name];
    });
  }

  handleAction($event) {
    const base = this;
    const action = $event.action;
    this.currentStrategyId = $event.id;
    if (action === 'delete') {
      if (this.org == 'trialtaxplaniq') {
        this.reveal.deleteChildren = true;
      } else {
        this.removeTaxStrategy($event);
      }
    } else if (action === 'edit') {
      this.editEngagement($event);
    } else if (action === 'publish') {
      this.publishStrategy($event);
    } else if (action === 'has-updates') {
      if ($event.locked){
        this.toastService.pop(TOAST_TYPE.info, 'To see more attorney client collaborated strategies, please purchase the full version of the software');
      } else {
        this.parentStrategyId = $event.parentStrategyId;
        if (this.parentStrategyId) {
          this.reveal.hasUpdates = true;
        }
      }
    } else if (action === 'hasDeletedByParent') {
      this.reveal.deletedByParent = true;
    } else if (action === 'view') {
      if ($event.locked){
        this.toastService.pop(TOAST_TYPE.info, 'To see more attorney client collaborated strategies, please purchase the full version of the software');
      } else {
        this.stateService.addState(new State('STRATEGIES_LIST', this._router.url, null, this.searchKey, null));
        this.loadingService.triggerLoadingEvent(true);
        this._router.navigate(['tax-planning', 'taxStrategies', $event.id]);
      }
    } else if (action === 'moveToActive') {
      this.moveStrategyToActive();
    } else if (action === 'videosExist' || action === 'documentsExist') {
      if ($event.locked){
        this.toastService.pop(TOAST_TYPE.info, 'To see more attorney client collaborated strategies, please purchase the full version of the software');
      } else {
        this.stateService.addState(new State('STRATEGIES_LIST', this._router.url, null, this.searchKey, null));
        this._router.navigate(['tax-planning', 'taxStrategies', $event.id, 'resources']);
      }
    } else if (action === 'rules') {
      if ($event.locked){
        this.toastService.pop(TOAST_TYPE.info, 'To see more attorney client collaborated strategies, please purchase the full version of the software');
      } else {
        this.openRulesPopup($event.id);
      }
    }
  }

  removeTaxStrategy($event) {
    this.toastService.pop(TOAST_TYPE.confirm, 'Are you sure you want to delete?', $event);
  }


  handleScroll(event: NgxScrollEvent) {
    const base = this;
    if (event.isReachingBottom && !base.isLoading && !event.isWindowEvent && this.hasNextSet) {
      base.isLoading = true;
      base.fetchNextSet(false);
    }
  }

  sortByColumn(obj) {
    this.sortInTaxStrategies(obj);
  }

  sortInTaxStrategies(obj) {
    this.enforceSingleSort(obj.column, obj.order);
    this.nextIndex = 0;

    const normalizedKey = this.getNormalizedSearchKey();
    if (normalizedKey) {
      // When there is a text search active, sort client-side over the filtered set
      const list = this.getFilteredStrategies();
      const columnName = obj.column;
      const isDesc = obj.order === 'desc';

      list.sort((a, b) => {
        const aVal = (a[columnName] ?? '').toString().toLowerCase();
        const bVal = (b[columnName] ?? '').toString().toLowerCase();

        if (aVal < bVal) {
          return isDesc ? 1 : -1;
        }
        if (aVal > bVal) {
          return isDesc ? -1 : 1;
        }
        return 0;
      });

      this.buildTaxStrategiesTableData(list, true);
      return;
    }

    // No text search → keep existing server-side sort logic
    let sortObj: any = {
      sortKey: obj.column,
      sortOrder: obj.order,
      fromIndex: this.nextIndex
    };
    if (!_.isEmpty(this.searchObj)) {
      sortObj = { ...sortObj, ...this.searchObj };
    }

    this.loadingService.triggerLoadingEvent(true);
    if (!_.isEmpty(this.searchObj)) {
      sortObj = { ...sortObj, ...this.searchObj };
      sortObj['status'] = this.searchObj.status || '';
      sortObj['category'] = this.searchObj.category || '';
      sortObj['applicableTo'] = this.searchObj.applicableTo || '';
    }
    this.taxStrategyServices.getPaginatedTaxStrategies(this.org, this.user, sortObj)
      .subscribe(response => {
        this.isLoading = false;
        this.taxStrategiesList = response;
        this.taxStrategyTableData.rows = [];
        this.loadingService.triggerLoadingEvent(false);
        this.buildTaxStrategiesTableData(response.strategies, true);
        this.nextIndex += response.strategies.length;
        this.hasNextSet = response.hasNextPage;
      }, error => {
        this.handleError(error);
      });
  }

  enforceSingleSort(column: string, order: string) {
    // Keep exactly one active sort at a time (for both request and UI indicator)
    this.taxStrategiesSort = {};
    if (column && order) {
      this.taxStrategiesSort[column] = order;
    }

    if (this.taxStrategyTableData?.columns) {
      this.taxStrategyTableData.columns.forEach(col => {
        col.sortType = col.name === column ? order : '';
      });
    }
  }

  resetSortOrder(sortOrder, columns, column) {
    _.each(columns, function(col){
      if (col.name !== column) {
        sortOrder[col.name] = '';
      }
    });
  }

  goToFormulaTestCases() {
    this._router.navigate(['tools', 'formula-test-cases']);
  }

  addNewTaxStrategy() {
    if (this.isMinimized){
      this.isMinimized = false;
      this.reveal.addNewStrategy = true;
    } else {
      this.editMode = false;
      this.taxStrategy = {
        resources: {
          files: [],
          links: '',
          videos: [{
            id: '',
            name: ''
          }]
        },
        firmCustomizations: {
          files: [],
          content: ''
        },
        clientResourceFiles: []
      };
      this.reveal.addNewStrategy = true;
    }
    // this.stateService.addState(new State('STRATEGIES_LIST', this._router.url, null, null));
    // this._router.navigate(['tax-planning', 'taxStrategies', 'add']);
  }

  editEngagement(data) {
    this.editMode = true;
    this.reveal.addNewStrategy = true;
    // this.stateService.addState(new State('STRATEGIES_LIST', this._router.url, null, this.searchKey, null));
    // this._router.navigate(['tax-planning', 'taxStrategies', data.id, 'edit']);
  }

  openRulesPopup(strategyId) {
    this.loadingService.triggerLoadingEvent(true);
    this.reveal.rules = true;
    this.isRulesLoading = true;
    this.ruleStrategy = {rules: {}};
    this.isRulesEditable = true;
    this.ruleEditBackup = null;
    this.taxStrategyServices.getTaxStrategyId(this.org, this.user, strategyId).subscribe(response => {
      const strategy = response.strategy || {};
      this.stratagiesTypes = response.strategyTypes || [];
      this.ruleStrategy = {
        ...strategy,
        rules: this.ensureRules(strategy.rules, strategy)
      };
      this.ruleEditBackup = _.cloneDeep(this.ruleStrategy.rules);
      this.isRulesLoading = false;
      this.loadingService.triggerLoadingEvent(false);
    }, error => {
      this.isRulesLoading = false;
      this.reveal.rules = false;
      this.loadingService.triggerLoadingEvent(false);
      this.handleError(error);
    });
  }

  hideRulesPopup() {
    this.reveal.rules = false;
    this.isRulesEditable = false;
    this.isRulesSaving = false;
  }

  ensureRules(rules, strategy = {}) {
    if (Array.isArray(rules)) {
      const firstRule = rules[0] || {};
      return {
        formula: firstRule.formula || '',
        planAmountFormula: firstRule.planAmountFormula || '',
        whyDescription: firstRule.whyDescription || '',
        fieldDescription: firstRule.fieldDescription || '',
        aiQJsonField: firstRule.aiQJsonField || '',
        aiQCategory: firstRule.aiQCategory || strategy['type'] || '',
        aiQGate: firstRule.aiQGate || '',
        aiQGateTitle: firstRule.aiQGateTitle || '',
        aiQDiscoveryQuestion: firstRule.aiQDiscoveryQuestion || '',
        aiQMinRisk: firstRule.aiQMinRisk || strategy['riskLevel'] || ''
      };
    }

    const baseRules = rules || {};
    return {
      formula: baseRules.formula || '',
      planAmountFormula: baseRules.planAmountFormula || '',
      whyDescription: baseRules.whyDescription || '',
      fieldDescription: baseRules.fieldDescription || '',
      aiQJsonField: baseRules.aiQJsonField || '',
      aiQCategory: baseRules.aiQCategory || strategy['type'] || '',
      aiQGate: baseRules.aiQGate || '',
      aiQGateTitle: baseRules.aiQGateTitle || '',
      aiQDiscoveryQuestion: baseRules.aiQDiscoveryQuestion || '',
      aiQMinRisk: baseRules.aiQMinRisk || strategy['riskLevel'] || ''
    };
  }

  enableRulesEdit() {
    if (this.isRulesLoading || this.isRulesSaving) {
      return;
    }
    this.isRulesEditable = true;
    this.ruleEditBackup = _.cloneDeep(this.ruleStrategy.rules);
  }

  cancelRulesEdit() {
    if (!this.isRulesEditable) {
      return;
    }
    this.ruleStrategy.rules = _.cloneDeep(this.ruleEditBackup || {});
    this.isRulesEditable = false;
  }

  saveRules() {
    if (!this.ruleStrategy || !this.ruleStrategy.id) {
      return;
    }
    this.loadingService.triggerLoadingEvent(true);
    this.isRulesSaving = true;
    const {
      formula,
      planAmountFormula,
      whyDescription,
      fieldDescription,
      aiQJsonField,
      aiQCategory,
      aiQGate,
      aiQGateTitle,
      aiQDiscoveryQuestion,
      aiQMinRisk
    } = this.ruleStrategy.rules || {};
    const payload = {
      id: this.ruleStrategy.id,
      name: this.ruleStrategy.name,
      formula,
      planAmountFormula,
      whyDescription,
      fieldDescription,
      aiQJsonField,
      aiQCategory,
      aiQGate,
      aiQGateTitle,
      aiQDiscoveryQuestion,
      aiQMinRisk
    };
    this.taxStrategyServices.saveStrategyRule(this.org, this.user, this.ruleStrategy.id, payload)
      .subscribe(() => {
        this.ruleStrategy.type = this.ruleStrategy.rules?.aiQCategory || this.ruleStrategy.type;
        this.ruleStrategy.riskLevel = this.ruleStrategy.rules?.aiQMinRisk || this.ruleStrategy.riskLevel;

        if (this.taxStrategiesList?.strategies?.length) {
          const rowStrategy = _.find(this.taxStrategiesList.strategies, { id: this.ruleStrategy.id });
          if (rowStrategy) {
            rowStrategy.type = this.ruleStrategy.type;
            rowStrategy.riskLevel = this.ruleStrategy.riskLevel;
          }
          this.buildTaxStrategiesTableData(this.taxStrategiesList.strategies, true);
        }

        this.isRulesSaving = false;
        this.isRulesEditable = false;
        this.ruleEditBackup = _.cloneDeep(this.ruleStrategy.rules);
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Rules updated');
      }, error => {
        this.isRulesSaving = false;
        this.loadingService.triggerLoadingEvent(false);
        this.handleError(error);
      });
  }

  handleError(error) {
    this.loadingService.triggerLoadingEvent(false);
    error = JSON.parse(error);
    const message = error.message ? error.message : `Failed To Perform Operation`;
    try {
      this.toastService.pop(TOAST_TYPE.error, message);
    } catch (e) {
      this.toastService.pop(TOAST_TYPE.error, message);
    }
  }

  deleteTaxStrategy(acceptence?) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.removeTaxStrategy(this.org, this.user, this.currentStrategyId, acceptence).subscribe(response => {
      this.getTaxStrategiesTableData();
      this.toastService.pop(TOAST_TYPE.success, 'Tax Strategy Deleted Successfully');
      this.isAddTaxStrategy = false;
      this.hideReveal('deleteChildren');
      this.loadingService.triggerLoadingEvent(false);
    }, error => {
      this.toastService.pop(TOAST_TYPE.error, 'Failed to delete strategy');
      this.handleError(error);
    });
  }

  filterData() {
    const filtered = this.getFilteredStrategies();
    this.buildTaxStrategiesTableData(filtered, true);
  }

  publishStrategy(data) {
    const obj: any = {};
    obj.strategyId = data.id;
    obj.isPublishStrategy = true;
    this.toastService.pop(TOAST_TYPE.confirm, 'Do you wish to publish this strategy to all instances?', obj);
  }

  publishStrategyToAllInstances(data) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.abilityOfPublishStrategy(this.org, this.user, data.strategyId).subscribe(response => {
      this.getTaxStrategiesTableData();
      if (response && response.message) {
        this.toastService.pop(TOAST_TYPE.success, response.message);
      } else {
        this.toastService.pop(TOAST_TYPE.success, 'Publish Successfully');
      }
      this.loadingService.triggerLoadingEvent(false);
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      try {
        const message = JSON.parse(error).message || 'Failed To Publish';
        this.toastService.pop(TOAST_TYPE.error, message);
      } catch (err) {
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Publish');
      }
    });
  }

  hideReveal(key, overrideMinimizeStatus?){
    this.parentStrategyId = '';
    this.currentStrategyId = '';
    this.reveal[key] = false;
  }

  acceptOrDenyUpdates(type) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.acceptUpdates(this.org, this.user, this.parentStrategyId, this.currentStrategyId, type).subscribe(response => {
      if (type === 'deny') {
        this.toastService.pop(TOAST_TYPE.success, 'Discarded the changes');
      } else {
        this.toastService.pop(TOAST_TYPE.success, 'Strategy changes have imported Successfully');
      }
      this.getTaxStrategiesTableData(true);
      this.hideReveal('hasUpdates');
    }, error => {
      this.handleError(error);
    });
  }

  acceptOrDenyDeletedByParent(type) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.acceptOrDenyDeletedByParent(this.org, this.user, this.currentStrategyId, type).subscribe(response => {
      if (type === 'delete') {
        this.toastService.pop(TOAST_TYPE.success, 'Tax Strategy Deleted Successfully');
      }
      this.getTaxStrategiesTableData();
      this.hideReveal('deletedByParent');
    }, error => {
      this.handleError(error);
    });
  }

  showAcceptAllUpdatesReveal() {
    this.reveal.acceptAll = true;
  }

  acceptAllStrategiesUpdates() {
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.acceptUpdatesOfAllStrategies(this.org, this.user).subscribe(response => {
      this.toastService.pop(TOAST_TYPE.success, 'Changes imported Successfully');
      this.getTaxStrategiesTableData(true);
      this.hideReveal('acceptAll');
    }, error => {
      this.handleError(error);
    });
  }


  onStrategyTypeSelect(event) {
    if (!_.isEmpty(event)) {
      this.taxStrategy.typeId = event.id;
    } else {
      this.taxStrategy.typeId = '';
    }
  }

  onStrategyAssociatedWithSelect(event) {
    if (!_.isEmpty(event)) {
      this.taxStrategy.associatedWith = event.id;
    } else {
      this.taxStrategy.associatedWith = '';
    }
  }

  addCustomTaxRate(){
    this.tempCustomRates.push({
      id: '',
      name: '',
      rate: '',
      formula: {
        actualValue: '',
        displayValue: '',
        displayValuesArray: [],
        actualValuesArray: []
      }
    });
    this.isCustomRateEdit = false;
    this.indexOfTempCustomRateObject = -1;
  }

  minimizeReveal(key){
    this.isMinimized = true;
    this.reveal[key] = false;
  }

  refreshStrategiesList() {
    this.reveal.addNewStrategy = false;
    this.getTaxStrategiesTableData(true);
  }

  moveStrategyToActive() {
    const data = {
      key: 'status',
      value: 'Active'
    };
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.archiveStrategy(this.org, this.user, this.currentStrategyId, data)
      .subscribe(success => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Strategy Archived successfully');
        this.nextIndex = 0;
        this.fetchNextSet(true);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed to archive strategy`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  getNormalizedSearchKey(): string {
    if (!this.searchKey) {
      return '';
    }
    // Trim and collapse internal whitespace
    return this.searchKey.trim().replace(/\s+/g, ' ');
  }

  getFilteredStrategies(): any[] {
    const key = this.getNormalizedSearchKey();
    const list = this.taxStrategiesList?.strategies || [];

    // No (effective) search → return full list
    if (!key) {
      return list;
    }

    const lowerKey = key.toLowerCase();
    const columns = this.formatColumnsForTable(this.taxStrategiesList.columns);
    const filteredList: any[] = [];

    _.each(list, (strategy) => {
      _.each(columns, (column) => {
        if (column.name !== 'tags') {
          const value = strategy[column.name];
          if (value && value.toString().toLowerCase().indexOf(lowerKey) !== -1) {
            const existing = _.find(filteredList, { id: strategy.id });
            if (!existing) {
              filteredList.push(strategy);
            }
          }
        }
      });
    });

    return filteredList;
  }

}

